import { createApi } from '@reduxjs/toolkit/query/react';

import { ENVS } from '@/shared/consts';

import { publicBaseQueryWithReauth } from '../queries/publicBaseQueryWithReauth';

export const adminService = createApi({
  reducerPath: 'adminApi',
  tagTypes: [
    'Schools',
    'SchoolInfo',
    'SchoolAbilities',
    'SchoolProgramSections',
    'SchoolSpeakers',
    'SchoolFAQs',
    'MainPages',
    'MainPage',
    'MainPageAboutSchool',
    'MainPageAdvantages',
    'MainPageReviews',
    'MainPageAboutBank',
    'MainPageFAQs',
    'MainPageContact',
    'SchoolParticipants',
    'SchoolParticipantsImports',
    'SchoolAdmissionSurvey',
    'SchoolAdmissionApplications',
    'SchoolAdmissionApplication',
    'SchoolTestingParticipants',
    'SchoolTestingParticipant',
    'SchoolAdmissionTesting',
    'SchoolEnrolledParticipants',
  ],
  baseQuery: publicBaseQueryWithReauth({
    baseUrl: ENVS.ADMIN_API_BASEURL,
  }),
  endpoints: () => ({}),
});
